import React, { useEffect, useState } from "react";
import API from "../api/api";

// Components
import Slider from "../components/Slider";
import StatCards from "../components/StatCards";
import LatestUpdates from "../components/LatestUpdates";
import SchemesList from "../components/SchemesList";
import StatesGrid from "../components/StatesGrid";

// Hook
import useCountAnimation from "../hooks/useCountAnimation";
import MostlyUsedLinks from "../components/MostlyUsedLinks";
const Home = () => {
  const [schemes, setSchemes] = useState([]);
  const [sliderImages, setSliderImages] = useState([]);
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
  const schemesRes = await API.get("/schemes");

  // Sort according to admin-set order
  const sortedSchemes = schemesRes.data.sort((a, b) => a.order - b.order);

  setSchemes(sortedSchemes);

  const sliderRes = await API.get("/slider");
  setSliderImages(sliderRes.data);

  await API.get("/visitors/hit");

  const v = await API.get("/visitors/get");
  setVisitorCount(v.data.count);
};


  const mainCategories = new Set(schemes.map((s) => s.mainCategory)).size;
  const categories = schemes.reduce((t, s) => t + s.categories.length, 0);
  const subCategories = schemes.reduce(
    (t, s) => t + s.categories.reduce((x, c) => x + c.subcategories.length, 0),
    0
  );

  const animVisitor = useCountAnimation(visitorCount);
  const animMain = useCountAnimation(mainCategories - 1);
  const animCat = useCountAnimation(categories - 1);
  const animSub = useCountAnimation(subCategories - 1);

  const allSub = schemes.flatMap((s) =>
    s.categories.flatMap((c) =>
      c.subcategories.map((x) => ({
        mainCategory: s.mainCategory,
        categoryName: c.name,
        subcategoryName: x.name,
        updatedAt: x.updatedAt || s.updatedAt,
      }))
    )
  );

  const recentItems = allSub
    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    .slice(0, 10);

  return (
    <>
      <Slider sliderImages={sliderImages} />

      <StatCards
        animVisitor={animVisitor}
        animMain={animMain}
        animCat={animCat}
        animSub={animSub}
      />



      <div className="container mb-5">
        <h2 className="mb-4 text-center fw-bold main-title">
          Government Schemes & Services
        </h2>

        <div className="row g-4">
          <div className="col-lg-4">
            <LatestUpdates recentItems={recentItems} />
          </div>

          <SchemesList schemes={schemes} />

        </div>
        {/* States section */}
        <div className="container mb-5">
          <h2 className="mb-3 mt-4 text-center fw-bold main-title">Explore Schemes By State</h2>
          <StatesGrid />
        </div>
        
        <MostlyUsedLinks />

      </div>
    </>
  );
};

export default Home;
